import { EntityLayout } from '@backstage/plugin-catalog';
import { AppStandardInsightsPage } from '@mercedes-benz/backstage-plugin-app-standard-insights';

import { EntityLayoutWrapper } from '../EntityLayoutWrapper';
import { GenericOverviewContent } from '../generic/OverviewContent';
import { TechdocsContent } from '../generic/TechdocsContent';

export const RepositoryPage = (
  <EntityLayoutWrapper>
    <EntityLayout.Route path="/" title="Overview">
      {GenericOverviewContent}
    </EntityLayout.Route>

    <EntityLayout.Route path="/appStandardInsights" title="AppStandardInsights">
      <AppStandardInsightsPage />
    </EntityLayout.Route>

    <EntityLayout.Route path="/docs" title="Docs">
      {TechdocsContent}
    </EntityLayout.Route>
  </EntityLayoutWrapper>
);
